export const generateFieldName = (key, index, name) =>
  `${key}[${index}].${name}`;

export const hasErrorField = (errors, key, index, name) => {
  const errorsArray = errors[key];
  return (
    errorsArray && errorsArray.length && Boolean(errorsArray[index]?.[name])
  );
};
